const AbiSKUMgmtApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/sku/get`,
  LIST: `${process.env.REACT_APP_USER_ABI_URL}/abi/sku/list`,
  POST: `${process.env.REACT_APP_USER_ABI_URL}/abi/sku/create`,
  PUT: `${process.env.REACT_APP_USER_ABI_URL}/abi/sku/update`,
  DELETE: `${process.env.REACT_APP_USER_ABI_URL}/abi/sku/delete`,
  CLONE: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/sku/clone`,
};

export default AbiSKUMgmtApiUrls
